import Vue from 'vue';
import Vuetify from 'vuetify';
import 'vuetify/dist/vuetify.min.css';
import colors from 'vuetify/lib/util/colors'
import 'material-design-icons-iconfont/dist/material-design-icons.css'
Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: '#08a3b8',
        primarylight5: colors.cyan.lighten5,
        primarylight4: colors.cyan.lighten4,
        primarylight3: colors.cyan.lighten3,
        primarylight2: colors.cyan.lighten2,
        primarylight1: colors.cyan.lighten1,
        primaryDark1: colors.cyan.darken1,
        primaryDark2: colors.cyan.darken2,
        primaryDark3: colors.cyan.darken3,
        primaryDark4: colors.cyan.darken4,
        primaryAccent1: colors.cyan.accent1,
        primaryAccent2: colors.cyan.accent2,
        primaryAccent3: colors.cyan.accent3,
        primaryBackground: colors.cyan.lighten5,
        secondary: '#AEEA00',
        secondaryDark: '#92c008',
        secondaryBackground: '#92c008',
        commentBackground: '#92c008',

        test: "#8c9eff",
        offrow: colors.red.lighten5,
        accent: '#82B1FF',
        error: '#FF5252',
        info: '#2196F3',
        success: '#4CAF50',
        warning: '#FFC107'
      },
    },
  },
  icons: {
    iconfont: 'md',
  },
  
});
